import {Map, List} from 'immutable';
import uuid from 'uuid';
import {filter} from 'lodash';
import {FILTER_GROUP_TYPE_GROUP, TYPES} from './TaxesActions';
import TaxesRegions from "./TaxesRegions";
import {getMultiNamesObject} from "../../utilities";

const initialState = {
  items: List(),
  currentItem: Map(),
  locationsHierarchy: List(Map()),
  loading: false,
  level: 0,
  searchText: '',

  // Global group filter to show all items from a specific group, in the header
  filterGroup: Map({name: TaxesRegions.currentRegion.getCurrentGroupAtLevel(0), type: FILTER_GROUP_TYPE_GROUP})
};

export default function taxesReducer(state = initialState, action) {
  switch (action.type) {
    case TYPES.ADD_NEW_ITEM:
      return addNewItem(state, action.itemType);
    case TYPES.GET_TAX_LOCATIONS_REQUEST:
      return {...state, loading: true};
    case TYPES.GET_TAX_LOCATIONS_ANSWER:
      return prepareItems(state, action.payload);
    case TYPES.REMOVE_ITEM:
      return removeItem(state, action);
    case TYPES.UPDATE_ITEM:
      return updateItem(state, action.payload);
    case TYPES.MAKE_ITEM_EDITABLE:
      break;
    case TYPES.SAVE_ITEMS_ANSWER:
      return {...state}
    case TYPES.SET_ITEMS_GROUP_ANSWER:
      return setItemsGroup(state, action.payload);
    case TYPES.ITEMS_DRILL_DOWN_ANSWER:
      return setItemDrillDown(state, action.payload);
    case TYPES.ITEMS_SET_SEARCH_TEXT_ANSWER:
      return setSearchText(state, action.payload);
    case TYPES.SET_FILTER_GROUP:
      let {filterGroup} = state;
      const {region, group} = action.payload;
      filterGroup = filterGroup.set('name', group);
      return {...state, filterGroup}
  }
  return state;
}

// Public Helper methods
export function getVisibleItems(state) {
  let items = state.items.filter(mi => !!mi.get('uid') || !mi.get('isDeleted'));
  items = items.map(item => item = item.set('isComplete', isItemComplete(item)));
  return items;
}

export function getChangesCount(state) {
  let cnt = 0;
  state.items.forEach(mi => {
    if (mi.get('isChanged')) cnt++
  });

  return cnt;
}

export const isItemComplete = item => {
  if (!item.get('materialRate') && !item.get('laborRate')) {
    return false;
  }
  const nameIntl = item.get('nameIntl');
  return item.get('name') || (nameIntl && Object.keys(nameIntl).some(key => nameIntl[key]))
};

export const isItemChanged = item => item.get('isChanged');

export function getBreadCrumbItems(state) {
  const res = [];
  let i = 1;
  const {locationsHierarchy, level} = state;
  res.push({name: '/', level: 0, id: uuid.v4(), root: true});
  locationsHierarchy.forEach(_ => res.push({level: i++, name: _.name, id: uuid.v4(), parentItem: _.parentItem}));
  //res.push({level, name: currentGroup.get('name'), id: uuid.v4()});
  return res;
}

// Private state changers
function setSearchText(state, {result, text}) {
  return {
    ...state,
    loading: false,
    items: List(result.rows.map(_ => Map(_))),
    searchText: text
  };
}

function setItemDrillDown(state, {parentItem, result, level}) {
  let {locationsHierarchy} = state;
  if (parentItem) {
    locationsHierarchy = locationsHierarchy.push({id: parentItem.id, level, name: parentItem.name, parentItem});
  }
  if (level === 0)
    locationsHierarchy = List();
  return {
    ...state,
    loading: false,
    items: List(result.rows.map(_ => Map(_))),
    currentItem: Map(parentItem),
    level,
    locationsHierarchy,
    searchText: ''
  };
}


function setItemsGroup(state, {group, result}) {
  return {
    ...state,
    loading: false,
    items: List(result.rows.map(_ => Map(_))),
    currentGroup: Map(group),
    searchText: ''
  };
}


const rgNumber = /^\d+[.\d]*$/;

function updateItem(state, {item, propertyName, value, isNumber, markAsChanged}) {
  let {items} = state;
  const idx = items.findIndex(mi => item.uid ? mi.get('uid') === item.uid : mi.get('id') === item.id);
  if (!isNumber) {
    items = items.setIn([idx, propertyName], value);
  } else {
    if (value === '' || rgNumber.test(value)) {
      items = items.setIn([idx, propertyName], value);
    }
  }

  if (markAsChanged) {
    items = items.setIn([idx, 'isChanged'], true);
  }

  return {...state, items};
}

function removeItem(state, {item}) {
  let {items} = state;
  if (item.uid) {
    const idx = items.findIndex(mi => mi.get('uid') === item.uid);
    items = items.deleteIn([idx]);
  } else if (item.id) {
    // is from DB, just mark it as hidden
    const idx = items.findIndex(mi => mi.get('id') === item.id);
    items = items.setIn([idx, 'isDeleted'], true).setIn([idx, 'isChanged'], true);
  }
  return {...state, items};
}

function addNewItem(state) {
  let {items} = state;
  return {
    ...state,
    searchText: '',
    items: items.unshift(Map({
      name: 'Not Used',
      nameIntl: getMultiNamesObject(""),
      materialRate: 0,
      laborRate: 0,
      isChanged: true,
      isEnabled: true,
      uid: uuid.v4()
    }))
  };
}

function prepareItems(state, answer) {
  return {
    ...state,
    loading: false,
    items: List(answer.rows.map(tax => {
      if (!tax.nameIntl) {
        tax.nameIntl = getMultiNamesObject(tax.name);
      }
      return Map(tax)
    }))
  };
}
